import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Modal} from 'react-bootstrap';
import UserForm from './userForm';
import * as Actions from 'actions';
import { displayNotice } from 'actions/error';

class CreateUser extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'CreateUser';

        this.cancel = this.cancel.bind(this);
        this.save = this.save.bind(this);
        this.next = this.next.bind(this);
    }
    save() {
    	if(this.props.users.user.is_admin && this.props.users.tmp_user.role === 'Client Admin') {
    		this.props.beginSignupClientAdmin(this.props.users.tmp_user)
    	}
    	else {
	    	this.props.beginCreateUser(this.props.users.tmp_user)
    	}
    }
    cancel() {
    	this.props.hideCreateUser();
    	this.props.clearShowIndividualFeatures();
    }
    next() {
    	let tab = this.props.users.open_tab;

    	if(tab === 'login_cred' || tab === '') {
    		this.props.setOpenTab('password')
    		this.props.setPasswordTabDirty()
    	}
    	else if(tab === 'password') {
    		this.props.setOpenTab('gen_info')
    		this.props.setGenInfoTabDirty()
    	}
    	else {
    		this.props.setOpenTab('profile_pic')
    		this.props.setProfilePicDirty();
    	}
    }

    render() {
      return (
      	 <div>
        	<Modal
        		show={this.props.users.creating_user}
        		onHide={this.cancel}
        		dialogClassName='create-user-modal'
        		bsSize="lg">
        		<div className="panel panel-primary mb-none">
        			<div className="panel-heading">
        				<h3 className="panel-title">Create User</h3>
        			</div>
        			<div className="panel-body">
        				<UserForm />
        			</div>
        			<div className="panel-footer">
        				<div className="row">
        					<div className="col-xs-12 col-md-2 col-md-offset-8 mb-sm">
        						<div onClick={this.cancel} className="btn btn-block btn-default">Cancel</div>
        					</div>
        					{(() => {
        						let tab = this.props.users.open_tab;
        						if((tab === 'login_cred' || tab === '' || tab === 'password' || tab === 'gen_info') &&
      								(!this.props.users.password_tab_dirty ||
      									!this.props.users.gen_info_tab_dirty ||
      									!this.props.users.profile_pic_tab_dirty))
        							return (
        								<div className="col-xs-12 col-md-2">
			        						<div onClick={this.next} className="btn btn-block btn-primary">Next</div>
			        					</div>
        							)
        						else
        							return (
        								<div className="col-xs-12 col-md-2">
			        						<div onClick={this.save} className="btn btn-block btn-primary">Save</div>
			        					</div>
        							)
        					})()}
        				</div>
        			</div>
        		</div>
        	</Modal>
        </div>
      );
    }
}

export default connect(({users}) => ({users}), Actions)(CreateUser);



// WEBPACK FOOTER //
// ./src/browser/components/users/createUser.js